import { render, staticRenderFns } from "./numbers.vue?vue&type=template&id=6656f210&scoped=true"
import script from "./numbers.vue?vue&type=script&lang=js"
export * from "./numbers.vue?vue&type=script&lang=js"
import style0 from "./numbers.vue?vue&type=style&index=0&id=6656f210&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656f210",
  null
  
)

export default component.exports